import axios from '../api/axios'

export default {
    getLst({params, callback}){ // 列表
        axios.post(`/v1/doshii/list`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    connectVenue({params, callback}){ // 关联指定场馆账号
        axios.put(`/v1/doshii/connect-venue`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    doshiiDetail({params, callback}){ // 查询详情
        axios.get(`/v1/doshii/detail/${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    delDoshii({params, callback}){
        axios.delete(`/v1/doshii/delete/${params}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getDeliveryPartners({callback}){ // 列表
        axios.get(`/v1/deliveryPartners`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    createDeliveryPartners({params, callback}){ // 新增
        axios.post(`/v1/deliveryPartners`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    updateDeliveryPartners({params, callback}){ // 修改
        axios.put(`/v1/deliveryPartners`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/doshii.js